export class Environment {
  public static isDevelopment =
    process.env.REACT_APP_STAGE === "local" ||
    process.env.REACT_APP_STAGE === "dev";
}
